// // ===== AGB CORE MODULE =====
// // Provides: module registry, event bus, scheduler, DOM cache, utilities
// (function (global) {
//     const ns = (global.AGB = global.AGB || {});

//     // Module registry
//     const defs = Object.create(null);
//     const cache = Object.create(null);

//     ns.define = function (name, deps, factory) {
//         defs[name] = { deps, factory };
//     };

//     ns.require = function (name) {
//         if (cache[name]) return cache[name];
//         const def = defs[name];
//         if (!def) throw new Error('AGB module not defined: ' + name);
//         const args = def.deps.map(ns.require);
//         const mod = def.factory.apply(null, args) || {};
//         cache[name] = mod;
//         return mod;
//     };

//     ns.load = function (url) {
//         return new Promise((res, rej) => {
//             const s = document.createElement('script');
//             s.src = url;
//             s.async = true;
//             s.onload = () => res();
//             s.onerror = rej;
//             document.head.appendChild(s);
//         });
//     };

//     // Event bus
//     const subs = new Map();
//     ns.bus = {
//         on(type, fn) {
//             (subs.get(type) || subs.set(type, new Set()).get(type)).add(fn);
//             return () => subs.get(type)?.delete(fn);
//         },
//         emit(type, payload) {
//             subs.get(type)?.forEach(fn => {
//                 try { fn(payload); } catch (e) { /* silently fail */ }
//             });
//         }
//     };

//     // Frame scheduler
//     ns.scheduler = (() => {
//         let dirty = { canvas: false, pricing: false, sticky: false, ui: false };
//         let rafId = null;
//         const subscribers = new Set();

//         function flush() {
//             rafId = null;
//             if (dirty.ui || dirty.canvas || dirty.pricing || dirty.sticky) {
//                 subscribers.forEach(fn => {
//                     try { fn(dirty); } catch (e) { /* silently fail */ }
//                 });
//                 dirty = { canvas: false, pricing: false, sticky: false, ui: false };
//             }
//         }

//         function mark(type) {
//             if (typeof type === 'string' && type in dirty) {
//                 dirty[type] = true;
//                 if (!rafId) {
//                     rafId = requestAnimationFrame(flush);
//                 }
//             }
//         }

//         function subscribe(fn) {
//             subscribers.add(fn);
//             return () => subscribers.delete(fn);
//         }

//         return { mark, subscribe };
//     })();

//     // DOM cache
//     ns.dom = (() => {
//         const cache = new Map();

//         function get(key, selector) {
//             if (!cache.has(key)) {
//                 const element = document.querySelector(selector);
//                 cache.set(key, element);
//             }
//             return cache.get(key);
//         }

//         function getById(id) {
//             const key = `#${id}`;
//             if (!cache.has(key)) {
//                 const element = document.getElementById(id);
//                 cache.set(key, element);
//             }
//             return cache.get(key);
//         }

//         function invalidate(key) {
//             if (key) {
//                 cache.delete(key);
//             } else {
//                 cache.clear();
//             }
//         }

//         const formId = () => window.AGB_FORM_ID || 'product-form';

//         return {
//             get form() { return getById(formId()); },
//             get continueBtn() { return getById('continue-btn'); },
//             get step1() { return getById('step1'); },
//             get step2() {
//                 // Try canonical id first
//                 const direct = getById('step2');
//                 if (direct) return direct;
//                 // Fallback to section-scoped ids like #agb-step2-<sectionId>
//                 const sectionScoped = get('step2_fallback_section', '[id^="agb-step2-"]');
//                 if (sectionScoped) return sectionScoped;
//                 // Final fallback to class-based container
//                 return get('step2_fallback_class', '.agb-step2');
//             },
//             get suggestionsWrapper() { return get('suggestionsWrapper', '.suggestions-wrapper'); },
//             get suggestionsList() { return getById('suggestions-list'); },
//             get suggestionsTitle() { return getById('suggestions-title'); },
//             get hiddenIdInput() { return this.form?.querySelector('input[name="id"]'); },
//             get gallery() { return get('gallery', 'product-gallery'); },
//             get canvas() { return getById('CustomProductCanvas'); },
//             get stickyBar() { return getById('agb-sticky-bar'); },
//             get stickyPrice() { return getById('agb-sticky-price'); },
//             get toolTray() { return getById('agb-canvas-tools'); },
//             get shareBtn() { return getById('share-btn'); },
//             get downloadBtn() { return getById('download-btn'); },
//             get sumBase() { return getById('sum-base'); },
//             get sumTotal() { return getById('sum-total'); },
//             invalidate,
//             clearCache: () => invalidate()
//         };
//     })();

//     // Utilities
//     ns.utils = {
//         log: (...args) => {
//             // Debug logging removed for production
//         },

//         // Get canvas transform configuration for a specific product handle
//         getCanvasTransform(productHandle) {
//             const transforms = ns.config.CANVAS_TRANSFORMS || {};
//             return transforms[productHandle] || transforms['default'] || {
//                 scale: 1.0,
//                 translateX: 0,
//                 translateY: 0,
//                 transformOrigin: 'center center'
//             };
//         },

//         // Universal user interaction tracker for variant options
//         trackUserInteraction(optionIndex) {
//             try {
//                 // Try modular Store first
//                 if (typeof ns.require === 'function') {
//                     const Store = ns.require('store');
//                     if (Store?.mutate) {
//                         Store.mutate(s => s.userInteractedOptions.add(optionIndex));
//                         return;
//                     }
//                 }

//                 // Fallback to legacy state
//                 if (window.state?.userInteractedOptions) {
//                     window.state.userInteractedOptions.add(optionIndex);
//                 }
//             } catch (e) {
//                 // Silently fail in production
//             }
//         },

//         waitForEl(sel, tries = 20, delay = 100) {
//             const el = document.querySelector(sel);
//             if (el) return Promise.resolve(el);
//             if (tries <= 0) return Promise.reject(new Error(`Missing: ${sel}`));
//             return new Promise(r => setTimeout(r, delay)).then(() => ns.utils.waitForEl(sel, tries - 1, delay));
//         },

//         toast(msg, actions = []) {
//             let wrap = document.getElementById('agb-toast-wrap');
//             if (!wrap) {
//                 wrap = document.createElement('div');
//                 wrap.id = 'agb-toast-wrap';
//                 document.body.appendChild(wrap);
//             }
//             const card = document.createElement('div');
//             card.className = 'agb-toast';
//             card.innerHTML = `<span style="font-weight:600">${msg}</span>`;
//             actions.forEach(a => {
//                 const btn = document.createElement('button');
//                 btn.textContent = a.label;
//                 btn.className = 'agb-toast-btn';
//                 btn.onclick = () => { try { a.onClick?.(); } finally { card.remove(); } };
//                 card.appendChild(btn);
//             });
//             wrap.appendChild(card);
//             setTimeout(() => card.remove(), 4500);
//         },

//         renderCardPrice({ container, qty = 1, price = 0, compareAt = 0, currency = (window.AGB_CURRENCY || '$') }) {
//             if (!container) return;
//             const q = Math.max(1, Number(qty) || 1);
//             const p = Number(price) || 0;
//             const c = Number(compareAt) || 0;
//             const unit = `${currency}${p.toFixed(2)}`;
//             const qtyPart = q == 1 ? '' : `${q} × `;
//             if (c > p) {
//                 const full = `${currency}${c.toFixed(2)}`;
//                 container.innerHTML = `<span class="qty">${qtyPart}</span><s class="compare">${full}</s> <span class="sale">${unit}</span>`;
//             } else {
//                 container.innerHTML = `<span class="qty">${qtyPart}</span><span class="regular">${unit}</span>`;
//             }
//         },

//         displayName(src) {
//             const item = (typeof src === 'string') ? { handle: src } : (src || {});
//             const fromTitle = item.title?.split(' (')[0]?.trim();
//             if (fromTitle) return fromTitle;
//             const h = item.handle || '';
//             if (!h) return 'this item';
//             return h.replace(/[-_]+/g, ' ').replace(/\b[a-z]/g, m => m.toUpperCase());
//         },

//         debounce(fn, delay) {
//             let timeoutId;
//             return (...args) => {
//                 clearTimeout(timeoutId);
//                 timeoutId = setTimeout(() => fn(...args), delay);
//             };
//         },

//         // Mobile stage rail management
//         openMobileStage(meta = {}) {
//             const step2Container = ns.dom.step2;
//             if (step2Container) {
//                 step2Container.hidden = false;
//                 step2Container.classList.add('is-open');
//                 document.body.classList.add('step2-rail-open');

//                 // Analytics
//                 if (window.DEBUG_LOGGER?.mobileStep2Open) {
//                     window.DEBUG_LOGGER.mobileStep2Open(meta);
//                 }

//                 // Mobile stage rail opened
//             }
//         },

//         closeMobileStage(meta = {}) {
//             const step2Container = ns.dom.step2;
//             if (step2Container) {
//                 step2Container.classList.remove('is-open');
//                 document.body.classList.remove('step2-rail-open');

//                 // Analytics
//                 if (window.DEBUG_LOGGER?.mobileStep2Close) {
//                     window.DEBUG_LOGGER.mobileStep2Close(meta);
//                 }

//                 // Mobile stage rail closed
//             }
//         }
//     };

//     // Error handler
//     ns.ErrorHandler = {
//         context: '[AGB]',
//         warn(operation, error, context = this.context) {
//             // Silently fail in production
//         },
//         safeSync(operation, fallback = null, context = 'unknown operation') {
//             try {
//                 return operation();
//             } catch (error) {
//                 this.warn(context, error);
//                 return fallback;
//             }
//         },
//         async safeOperation(operation, fallback = null, context = 'unknown operation') {
//             try {
//                 return await operation();
//             } catch (error) {
//                 this.warn(context, error);
//                 return fallback;
//             }
//         }
//     };

//     // Config
//     ns.config = {
//         DEBUG: false,
//         CDN_BASE: 'https://cdn.shopify.com/s/files/1/0526/4001/files/',
//         CANVAS_WIDTH: 1147,
//         CANVAS_HEIGHT: 1737,
//         MAX_CACHE_SIZE: 50,
//         BATCH_SIZE: 20,
//         FLUSH_INTERVAL_MS: 5000,
//         FLUSH_ACTIVITY_THRESHOLD: 3,
//         MAX_KEEP_EVENTS: 500,
//         MOBILE_STACK_BREAKPOINT: 1000,
//         ANALYTICS_ENABLED: true,

//         // Canvas transform configurations per product handle
//         CANVAS_TRANSFORMS: {
//             // Default configuration (fallback)
//             'default': {
//                 scale: 1.0,
//                 translateX: 0,
//                 translateY: 0,
//                 transformOrigin: 'center center'
//             },

//             // Reaper rig test - zoomed in to focus on content
//             'reaper-rig-test': {
//                 scale: 1.3, // Zoom in 30%
//                 translateX: 0,
//                 translateY: 0, // Shift up to focus on main content
//                 transformOrigin: 'center center'
//             },

//             // Reaper rig test - zoomed in to focus on content
//             'reaper-chest-rig': {
//                 scale: 1.3, // Zoom in 30%
//                 translateX: 0,
//                 translateY: 0, // Shift up to focus on main content
//                 transformOrigin: 'center center'
//             },
//             // Reaper rig test - zoomed in to focus on content
//             'reaper-rig-micro-rig-bundle': {
//                 scale: 1.3, // Zoom in 30%
//                 translateX: 0,
//                 translateY: 0, // Shift up to focus on main content
//                 transformOrigin: 'center center'
//             }
//         }
//     };

//     // Environment
//     ns.env = {
//         boot: null,
//         startedAt: 0
//     };

//     // Universal variant option interaction tracking
//     const variantTrackingCleanup = [];

//     function setupVariantInteractionTracking() {
//         // Track clicks on variant option inputs
//         const clickHandler = (e) => {
//             const target = e.target;
//             if (!target) return;

//             // Check for variant option inputs
//             const nameAttr = target.getAttribute('name') || '';
//             const match = nameAttr.match(/^option(\d+)$/i);
//             if (match) {
//                 const optionIndex = parseInt(match[1], 10) - 1; // Convert to 0-based
//                 if (!isNaN(optionIndex)) {
//                     ns.utils.trackUserInteraction(optionIndex);
//                 }
//             }

//             // Check for custom swatches
//             const optionIndex = target.getAttribute('data-option-index');
//             if (optionIndex !== null) {
//                 const idx = parseInt(optionIndex, 10);
//                 if (!isNaN(idx)) {
//                     ns.utils.trackUserInteraction(idx);
//                 }
//             }
//         };

//         // Track changes on select elements
//         const changeHandler = (e) => {
//             const target = e.target;
//             if (!target || target.tagName !== 'SELECT') return;

//             const nameAttr = target.getAttribute('name') || '';
//             const match = nameAttr.match(/^option(\d+)$/i);
//             if (match) {
//                 const optionIndex = parseInt(match[1], 10) - 1; // Convert to 0-based
//                 if (!isNaN(optionIndex)) {
//                     ns.utils.trackUserInteraction(optionIndex);
//                 }
//             }
//         };

//         document.addEventListener('click', clickHandler);
//         document.addEventListener('change', changeHandler);

//         // Store cleanup functions
//         variantTrackingCleanup.push(() => {
//             document.removeEventListener('click', clickHandler);
//             document.removeEventListener('change', changeHandler);
//         });
//     }

//     // Global cleanup coordinator
//     ns.cleanup = function () {
//         try {
//             // Clean up variant tracking event listeners
//             variantTrackingCleanup.forEach(fn => {
//                 try { fn(); } catch (e) { /* silently fail */ }
//             });
//             variantTrackingCleanup.length = 0;

//             // Unmount all modules in reverse order of initialization
//             if (typeof ns.require === 'function') {
//                 try { ns.require('suggest')?.unmount?.(); } catch (e) { /* silently fail */ }
//                 try { ns.require('canvas')?.unmount?.(); } catch (e) { /* silently fail */ }
//                 try { ns.require('panels')?.unmount?.(); } catch (e) { /* silently fail */ }
//                 try { ns.require('variant')?.cleanup?.(); } catch (e) { /* silently fail */ }
//                 try { ns.require('analytics')?.stop?.(); } catch (e) { /* silently fail */ }
//                 try { ns.require('store')?.cleanup?.(); } catch (e) { /* silently fail */ }
//             }
//             // Global cleanup completed
//         } catch (e) {
//             // Cleanup failed
//         }
//     };

//     // Bootstrap
//     ns.bootstrap = function (boot) {
//         ns.env.boot = boot || {};
//         ns.env.startedAt = performance.now ? performance.now() : Date.now();
//         // Bootstrap completed

//         // Set up universal interaction tracking
//         setupVariantInteractionTracking();

//         // Wire global cleanup on page unload
//         window.addEventListener('beforeunload', ns.cleanup);

//         // Emit ready event
//         ns.bus.emit('core:ready', ns.env.boot);
//     };

//     // Define core module
//     ns.define('core', [], function () {
//         return {
//             bootstrap: ns.bootstrap,
//             cleanup: ns.cleanup,
//             bus: ns.bus,
//             scheduler: ns.scheduler,
//             dom: ns.dom,
//             utils: ns.utils,
//             config: ns.config,
//             ErrorHandler: ns.ErrorHandler
//         };
//     });

//     // Expose cleanup globally for external access
//     window.AGB_CLEANUP = ns.cleanup;

//     // agb-core.js loaded
// })(window);


// ===== AGB CORE MODULE =====
// Provides: module registry, event bus, scheduler, DOM cache, utilities
(function (global) {
    const ns = (global.AGB = global.AGB || {});

    // Module registry
    const defs = Object.create(null);
    const cache = Object.create(null);

    ns.define = function (name, deps, factory) {
        defs[name] = { deps, factory };
    };

    ns.require = function (name) {
        if (cache[name]) return cache[name];
        const def = defs[name];
        if (!def) throw new Error('AGB module not defined: ' + name);
        const args = def.deps.map(ns.require);
        const mod = def.factory.apply(null, args) || {};
        cache[name] = mod;
        return mod;
    };

    ns.load = function (url) {
        return new Promise((res, rej) => {
            const s = document.createElement('script');
            s.src = url;
            s.async = true;
            s.onload = () => res();
            s.onerror = rej;
            document.head.appendChild(s);
        });
    };

    // Event bus
    const subs = new Map();
    ns.bus = {
        on(type, fn) {
            (subs.get(type) || subs.set(type, new Set()).get(type)).add(fn);
            return () => subs.get(type)?.delete(fn);
        },
        emit(type, payload) {
            subs.get(type)?.forEach(fn => {
                try { fn(payload); } catch (e) { /* silently fail */ }
            });
        }
    };

    // Frame scheduler
    ns.scheduler = (() => {
        let dirty = { canvas: false, pricing: false, sticky: false, ui: false };
        let rafId = null;
        const subscribers = new Set();

        function flush() {
            rafId = null;
            if (dirty.ui || dirty.canvas || dirty.pricing || dirty.sticky) {
                subscribers.forEach(fn => {
                    try { fn(dirty); } catch (e) { /* silently fail */ }
                });
                dirty = { canvas: false, pricing: false, sticky: false, ui: false };
            }
        }

        function mark(type) {
            if (typeof type === 'string' && type in dirty) {
                dirty[type] = true;
                if (!rafId) {
                    rafId = requestAnimationFrame(flush);
                }
            }
        }

        function subscribe(fn) {
            subscribers.add(fn);
            return () => subscribers.delete(fn);
        }

        return { mark, subscribe };
    })();

    // DOM cache
    ns.dom = (() => {
        const cache = new Map();

        function get(key, selector) {
            if (!cache.has(key)) {
                const element = document.querySelector(selector);
                cache.set(key, element);
            }
            return cache.get(key);
        }

        function getById(id) {
            const key = `#${id}`;
            if (!cache.has(key)) {
                const element = document.getElementById(id);
                cache.set(key, element);
            }
            return cache.get(key);
        }

        function invalidate(key) {
            if (key) {
                cache.delete(key);
            } else {
                cache.clear();
            }
        }

        const formId = () => window.AGB_FORM_ID || 'product-form';

        return {
            get form() { return getById(formId()); },
            get continueBtn() { return getById('continue-btn'); },
            get step1() { return getById('step1'); },
            get step2() {
                // Try canonical id first
                const direct = getById('step2');
                if (direct) return direct;
                // Fallback to section-scoped ids like #agb-step2-<sectionId>
                const sectionScoped = get('step2_fallback_section', '[id^="agb-step2-"]');
                if (sectionScoped) return sectionScoped;
                // Final fallback to class-based container
                return get('step2_fallback_class', '.agb-step2');
            },
            get suggestionsWrapper() { return get('suggestionsWrapper', '.suggestions-wrapper'); },
            get suggestionsList() { return getById('suggestions-list'); },
            get suggestionsTitle() { return getById('suggestions-title'); },
            get hiddenIdInput() { return this.form?.querySelector('input[name="id"]'); },
            get gallery() { return get('gallery', 'product-gallery'); },
            get canvas() { return getById('CustomProductCanvas'); },
            get stickyBar() { return getById('agb-sticky-bar'); },
            get stickyPrice() { return getById('agb-sticky-price'); },
            get toolTray() { return getById('agb-canvas-tools'); },
            get shareBtn() { return getById('share-btn'); },
            get downloadBtn() { return getById('download-btn'); },
            get sumBase() { return getById('sum-base'); },
            get sumTotal() { return getById('sum-total'); },
            invalidate,
            clearCache: () => invalidate()
        };
    })();

    // Utilities
    ns.utils = {
        log: (...args) => {
            // Debug logging removed for production
        },

        // Get canvas transform configuration for a specific product handle
        getCanvasTransform(productHandle) {
            const transforms = ns.config.CANVAS_TRANSFORMS || {};
            return transforms[productHandle] || transforms['default'] || {
                scale: 1.0,
                translateX: 0,
                translateY: 0,
                transformOrigin: 'center center'
            };
        },

        // Universal user interaction tracker for variant options
        trackUserInteraction(optionIndex) {
            try {
                // Try modular Store first
                if (typeof ns.require === 'function') {
                    const Store = ns.require('store');
                    if (Store?.mutate) {
                        Store.mutate(s => s.userInteractedOptions.add(optionIndex));
                        return;
                    }
                }

                // Fallback to legacy state
                if (window.state?.userInteractedOptions) {
                    window.state.userInteractedOptions.add(optionIndex);
                }
            } catch (e) {
                // Silently fail in production
            }
        },

        waitForEl(sel, tries = 20, delay = 100) {
            const el = document.querySelector(sel);
            if (el) return Promise.resolve(el);
            if (tries <= 0) return Promise.reject(new Error(`Missing: ${sel}`));
            return new Promise(r => setTimeout(r, delay)).then(() => ns.utils.waitForEl(sel, tries - 1, delay));
        },

        toast(msg, actions = []) {
            let wrap = document.getElementById('agb-toast-wrap');
            if (!wrap) {
                wrap = document.createElement('div');
                wrap.id = 'agb-toast-wrap';
                document.body.appendChild(wrap);
            }
            const card = document.createElement('div');
            card.className = 'agb-toast';
            card.innerHTML = `<span style="font-weight:600">${msg}</span>`;
            actions.forEach(a => {
                const btn = document.createElement('button');
                btn.textContent = a.label;
                btn.className = 'agb-toast-btn';
                btn.onclick = () => { try { a.onClick?.(); } finally { card.remove(); } };
                card.appendChild(btn);
            });
            wrap.appendChild(card);
            setTimeout(() => card.remove(), 4500);
        },

        renderCardPrice({ container, qty = 1, price = 0, compareAt = 0, currency = null }) {
            if (!container) return;
            
            // Get currency from store-config if available, otherwise fall back to window.AGB_CURRENCY or '$'
            if (!currency) {
                try {
                    const StoreConfig = AGB?.require?.('store-config');
                    currency = StoreConfig?.getCurrency?.() || window.AGB_CURRENCY || '$';
                } catch {
                    currency = window.AGB_CURRENCY || '$';
                }
            }
            
            const q = Math.max(1, Number(qty) || 1);
            const p = Number(price) || 0;
            const c = Number(compareAt) || 0;
            const unit = `${currency}${p.toFixed(2)}`;
            const qtyPart = q == 1 ? '' : `${q} × `;
            if (c > p) {
                const full = `${currency}${c.toFixed(2)}`;
                container.innerHTML = `<span class="qty">${qtyPart}</span><s class="compare">${full}</s> <span class="sale">${unit}</span>`;
            } else {
                container.innerHTML = `<span class="qty">${qtyPart}</span><span class="regular">${unit}</span>`;
            }
        },

        displayName(src) {
            const item = (typeof src === 'string') ? { handle: src } : (src || {});
            const fromTitle = item.title?.split(' (')[0]?.trim();
            if (fromTitle) return fromTitle;
            const h = item.handle || '';
            if (!h) return 'this item';
            return h.replace(/[-_]+/g, ' ').replace(/\b[a-z]/g, m => m.toUpperCase());
        },

        debounce(fn, delay) {
            let timeoutId;
            return (...args) => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => fn(...args), delay);
            };
        },

        // Mobile stage rail management
        openMobileStage(meta = {}) {
            const step2Container = ns.dom.step2;
            if (step2Container) {
                step2Container.hidden = false;
                step2Container.classList.add('is-open');
                document.body.classList.add('step2-rail-open');

                // Analytics
                if (window.DEBUG_LOGGER?.mobileStep2Open) {
                    window.DEBUG_LOGGER.mobileStep2Open(meta);
                }

                // Mobile stage rail opened
            }
        },

        closeMobileStage(meta = {}) {
            const step2Container = ns.dom.step2;
            if (step2Container) {
                step2Container.classList.remove('is-open');
                document.body.classList.remove('step2-rail-open');

                // Analytics
                if (window.DEBUG_LOGGER?.mobileStep2Close) {
                    window.DEBUG_LOGGER.mobileStep2Close(meta);
                }

                // Mobile stage rail closed
            }
        }
    };

    // Error handler
    ns.ErrorHandler = {
        context: '[AGB]',
        warn(operation, error, context = this.context) {
            // Silently fail in production
        },
        safeSync(operation, fallback = null, context = 'unknown operation') {
            try {
                return operation();
            } catch (error) {
                this.warn(context, error);
                return fallback;
            }
        },
        async safeOperation(operation, fallback = null, context = 'unknown operation') {
            try {
                return await operation();
            } catch (error) {
                this.warn(context, error);
                return fallback;
            }
        }
    };

    // Config
    ns.config = {
        DEBUG: false,
        CDN_BASE: 'https://cdn.shopify.com/s/files/1/0526/4001/files/',
        CANVAS_WIDTH: 1147,
        CANVAS_HEIGHT: 1737,
        MAX_CACHE_SIZE: 50,
        BATCH_SIZE: 20,
        FLUSH_INTERVAL_MS: 5000,
        FLUSH_ACTIVITY_THRESHOLD: 3,
        MAX_KEEP_EVENTS: 500,
        MOBILE_STACK_BREAKPOINT: 1000,
        ANALYTICS_ENABLED: true,  // ON, but narrowed to check/uncheck/info via GB_ALLOWED_EVENTS in agb-analytics.js (2026-06-25, per Dorian)

        // Canvas transform configurations per product handle
        CANVAS_TRANSFORMS: {
            // Default configuration (fallback)
            'default': {
                scale: 1.0,
                translateX: 0,
                translateY: 0,
                transformOrigin: 'center center'
            },

            // Reaper rig test - zoomed in to focus on content
            'reaper-rig-test': {
                scale: 1.3, // Zoom in 30%
                translateX: 0,
                translateY: 0, // Shift up to focus on main content
                transformOrigin: 'center center'
            },

            // Reaper rig test - zoomed in to focus on content
            'reaper-chest-rig': {
                scale: 1.3, // Zoom in 30%
                translateX: 0,
                translateY: 0, // Shift up to focus on main content
                transformOrigin: 'center center'
            },
            // Reaper rig test - zoomed in to focus on content
            'reaper-rig-micro-rig-bundle': {
                scale: 1.3, // Zoom in 30%
                translateX: 0,
                translateY: 0, // Shift up to focus on main content
                transformOrigin: 'center center'
            }
        }
    };

    // Environment
    ns.env = {
        boot: null,
        startedAt: 0
    };

    // Universal variant option interaction tracking
    const variantTrackingCleanup = [];

    function setupVariantInteractionTracking() {
        // Track clicks on variant option inputs
        const clickHandler = (e) => {
            const target = e.target;
            if (!target) return;

            // Check for variant option inputs
            const nameAttr = target.getAttribute('name') || '';
            const match = nameAttr.match(/^option(\d+)$/i);
            if (match) {
                const optionIndex = parseInt(match[1], 10) - 1; // Convert to 0-based
                if (!isNaN(optionIndex)) {
                    ns.utils.trackUserInteraction(optionIndex);
                }
            }

            // Check for custom swatches
            const optionIndex = target.getAttribute('data-option-index');
            if (optionIndex !== null) {
                const idx = parseInt(optionIndex, 10);
                if (!isNaN(idx)) {
                    ns.utils.trackUserInteraction(idx);
                }
            }
        };

        // Track changes on select elements
        const changeHandler = (e) => {
            const target = e.target;
            if (!target || target.tagName !== 'SELECT') return;

            const nameAttr = target.getAttribute('name') || '';
            const match = nameAttr.match(/^option(\d+)$/i);
            if (match) {
                const optionIndex = parseInt(match[1], 10) - 1; // Convert to 0-based
                if (!isNaN(optionIndex)) {
                    ns.utils.trackUserInteraction(optionIndex);
                }
            }
        };

        document.addEventListener('click', clickHandler);
        document.addEventListener('change', changeHandler);

        // Store cleanup functions
        variantTrackingCleanup.push(() => {
            document.removeEventListener('click', clickHandler);
            document.removeEventListener('change', changeHandler);
        });
    }

    // Global cleanup coordinator
    ns.cleanup = function () {
        try {
            // Clean up variant tracking event listeners
            variantTrackingCleanup.forEach(fn => {
                try { fn(); } catch (e) { /* silently fail */ }
            });
            variantTrackingCleanup.length = 0;

            // Unmount all modules in reverse order of initialization
            if (typeof ns.require === 'function') {
                try { ns.require('suggest')?.unmount?.(); } catch (e) { /* silently fail */ }
                try { ns.require('canvas')?.unmount?.(); } catch (e) { /* silently fail */ }
                try { ns.require('panels')?.unmount?.(); } catch (e) { /* silently fail */ }
                try { ns.require('variant')?.cleanup?.(); } catch (e) { /* silently fail */ }
                try { ns.require('analytics')?.stop?.(); } catch (e) { /* silently fail */ }
                try { ns.require('store')?.cleanup?.(); } catch (e) { /* silently fail */ }
            }
            // Global cleanup completed
        } catch (e) {
            // Cleanup failed
        }
    };

    // Bootstrap
    ns.bootstrap = function (boot) {
        ns.env.boot = boot || {};
        ns.env.startedAt = performance.now ? performance.now() : Date.now();
        // Bootstrap completed

        // Set up universal interaction tracking
        setupVariantInteractionTracking();

        // Wire global cleanup on page unload
        window.addEventListener('beforeunload', ns.cleanup);

        // Emit ready event
        ns.bus.emit('core:ready', ns.env.boot);
    };

    // Define core module
    ns.define('core', [], function () {
        return {
            bootstrap: ns.bootstrap,
            cleanup: ns.cleanup,
            bus: ns.bus,
            scheduler: ns.scheduler,
            dom: ns.dom,
            utils: ns.utils,
            config: ns.config,
            ErrorHandler: ns.ErrorHandler
        };
    });

    // Expose cleanup globally for external access
    window.AGB_CLEANUP = ns.cleanup;

    // agb-core.js loaded
})(window);